// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"26213a28","150":"022ce580","182":"605e455f","311":"3358ee1c","312":"a6102330","332":"5d852ef0","705":"0834f928"}[chunkId] + ".chunk.js";
};